/**
 * Seção "Vocabulário" em modo leitura (Brief 4 · Tela 2 · PR2).
 *
 * Renderiza `vocabulary.preferredTerms` / `avoidedTerms` como chips de LEITURA
 * (sem o `×`/+Adicionar do gabarito editável). Lista vazia → "Nenhum definido",
 * espelhando playbooks/tabs/TabGeneralRead (zero dado falso, nunca esconde).
 */

import type { PersonaVocabulary } from '../types';

function ChipList({ terms }: { terms: string[] }): JSX.Element {
  if (terms.length === 0) {
    return <p className="pe-read-value pe-read-value--muted">Nenhum definido</p>;
  }
  return (
    <div className="pe-chip-row">
      {terms.map((term) => (
        <span key={term} className="pe-chip">
          {term}
        </span>
      ))}
    </div>
  );
}

export function SectionVocabularyRead({
  vocabulary,
}: {
  vocabulary: PersonaVocabulary;
}): JSX.Element {
  return (
    <section className="pe-panel">
      <h2 className="pe-panel__title">Vocabulário</h2>
      {/* 06/Ago/2026 — «Termos preferidos» saiu daqui e do editor junto com a emissão no prompt
          (vide `SectionVocabularyEdit` para o motivo medido). O dado permanece no banco; deixou
          de ser mostrado porque mostrar um campo que não afeta a IA é afirmar o que não é. */}
      <p className="pe-panel__subtitle">
        Termos que a IA deve evitar. O vocabulário que ela <em>usa</em> vem dos exemplos.
      </p>
      <div className="pe-field">
        <span className="pe-field__label">Termos a evitar</span>
        <ChipList terms={vocabulary.avoidedTerms} />
      </div>
    </section>
  );
}
